import { render, staticRenderFns } from "./alarm-table.vue?vue&type=template&id=50c32922&scoped=true&"
import script from "./alarm-table.vue?vue&type=script&lang=ts&"
export * from "./alarm-table.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-table.vue?vue&type=style&index=0&id=50c32922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c32922",
  null
  
)

export default component.exports